
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useClickOutside.html",
      function () {
        return require("private-next-pages/Hooks/useClickOutside.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useClickOutside.html"])
      });
    }
  